import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environement';
import { EtablissementResponseDTO } from '../../../models/EtablissementResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class EtablissementService {
  private baseUrl = environment.apiUrl + '/api/v1/etablissements';

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  private getAuthHeaders(): HttpHeaders {
    if (isPlatformBrowser(this.platformId)) {
      const token = localStorage.getItem('presence');
      return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
    }
    return new HttpHeaders();
  }

  getEtablissementById(id: number): Observable<EtablissementResponseDTO> {
    return this.http.get<EtablissementResponseDTO>(`${this.baseUrl}/${id}`, {
      headers: this.getAuthHeaders()
    });
  }
}
